import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MetricKey, MetricPayload, MetricView, MetricsFacade, getMetricPayload } from '@app/shared/+state/metrics';
import { LoadingState } from '@app/shared/interfaces';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { LoadingSize } from '@app/ui/loading-mono/loading.component.interface';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'hospitable-list-view-dialog',
  templateUrl: './list-view-dialog.component.html',
  styleUrls: ['./list-view-dialog.component.scss'],
})
export class ListViewDialogComponent implements OnInit {
  LoadingState = LoadingState;
  metricKey: MetricKey;
  loadingState$: Observable<LoadingState | null> = of(LoadingState.NotSent);
  LoadingSize = LoadingSize;

  views$: Observable<MetricView[] | null>;
  activeView$: Observable<MetricView | null>;

  uuid: string | undefined;

  updatedViewUUID: string | undefined;
  deletingViewUUID: string | undefined;

  constructor(
    public dialogRef: MatDialogRef<ListViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private metricsFacade: MetricsFacade,
    private notificationService: ToastNotificationsService
  ) {}

  ngOnInit() {
    if (this.dialogData) {
      const { metricKey } = this.dialogData;
      this.metricKey = metricKey;
      switch (this.metricKey) {
        case MetricKey.Reservations: {
          this.views$ = this.metricsFacade.reservationViews$;
          this.activeView$ = this.metricsFacade.activeReservationView$;
          break;
        }
        case MetricKey.Taxes: {
          this.views$ = this.metricsFacade.taxesViews$;
          this.activeView$ = this.metricsFacade.activeTaxesView$;
          break;
        }
        case MetricKey.Reviews: {
          this.views$ = this.metricsFacade.reviewsViews$;
          this.activeView$ = this.metricsFacade.activeReviewsView$;
          break;
        }
        case MetricKey.Tasks: {
          this.views$ = this.metricsFacade.tasksViews$;
          this.activeView$ = this.metricsFacade.activeTasksView$;
          break;
        }
      }
    }
  }

  onChangeActiveViewUUID(uuid: string) {
    if (uuid) {
      this.uuid = uuid;
    }
  }

  copiedToClipboard() {
    this.notificationService.notificationOpen('Copied to clipboard');
  }

  deleteView(view: MetricView) {
    if (this.metricKey) {
      this.deletingViewUUID = view.uuid;

      switch (this.metricKey) {
        case MetricKey.Reservations: {
          this.loadingState$ = this.metricsFacade.deleteReservationViewLoadingState$;
          this.metricsFacade.deleteReservationView(view.uuid);
          break;
        }
        case MetricKey.Taxes: {
          this.loadingState$ = this.metricsFacade.deleteTaxesViewLoadingState$;
          this.metricsFacade.deleteTaxesView(view.uuid);
          break;
        }
        case MetricKey.Reviews: {
          this.loadingState$ = this.metricsFacade.deleteReviewsViewLoadingState$;
          this.metricsFacade.deleteReviewsView(view.uuid);
          break;
        }
        case MetricKey.Tasks: {
          this.loadingState$ = this.metricsFacade.deleteTasksViewLoadingState$;
          this.metricsFacade.deleteTasksView(view.uuid);
          break;
        }
      }
    }
  }

  updateView(view: MetricView, publicly_available: boolean) {
    this.updatedViewUUID = view.uuid;
    const payload: MetricPayload = getMetricPayload(view.filters);

    switch (this.metricKey) {
      case MetricKey.Reservations: {
        this.loadingState$ = this.metricsFacade.updateReservationViewLoadingState$;
        this.metricsFacade.updateReservationView(view.uuid, {
          name: view.name,
          publicly_available,
          ...payload,
        });
        break;
      }
      case MetricKey.Taxes: {
        this.loadingState$ = this.metricsFacade.updateTaxesViewLoadingState$;
        this.metricsFacade.updateTaxesView(view.uuid, {
          name: view.name,
          publicly_available,
          ...payload,
        });
        break;
      }
      case MetricKey.Reviews: {
        this.loadingState$ = this.metricsFacade.updateReviewsViewLoadingState$;
        this.metricsFacade.updateReviewsView(view.uuid, {
          name: view.name,
          publicly_available,
          ...payload,
        });
        break;
      }
      case MetricKey.Tasks: {
        this.loadingState$ = this.metricsFacade.updateTasksViewLoadingState$;
        this.metricsFacade.updateTasksView(view.uuid, {
          name: view.name,
          publicly_available,
          ...payload,
        });
        break;
      }
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  applyView() {
    if (this.uuid) {
      switch (this.metricKey) {
        case MetricKey.Reservations: {
          this.metricsFacade.switchActiveReservationView(this.uuid);
          break;
        }
        case MetricKey.Taxes: {
          this.metricsFacade.switchActiveTaxesView(this.uuid);
          break;
        }
        case MetricKey.Reviews: {
          this.metricsFacade.switchActiveReviewsView(this.uuid);
          break;
        }
        case MetricKey.Tasks: {
          this.metricsFacade.switchActiveTasksView(this.uuid);
          break;
        }
      }
    }
    this.dialogRef.close();
  }
}
